import {Observable} from 'rxjs';
import {
    MxGridCustomizerEvent,
    MxGridDisableRowFn,
    MxGridProps,
    MxGridSelectionChangedFn
} from '../../mx-grid/services/mx-grid-customizer-event';
import {AssignmentSelectionType} from '../../mx-grid/services/selection-type.model';
import {MxReportViewInputFilterDefault} from '../../mx-report-view/services/mx-report-view-customizer-event';
import {AssignmentConfig, AssignmentResult} from './mx-assignment-grid';

export class MxAssignmentGridActionsConfig {
    event: MxGridCustomizerEvent;
    componentName?: string;
    reportName?: string;
    recordsName: string;
    saveSuccessMessage?: string;
    saveAssignments?: boolean = true;
    handleSaveError?: boolean = false;
    reloadAfterSave?: boolean = false;
    filterDefaults?: MxReportViewInputFilterDefault[] | MxReportViewInputFilterDefaultFn;
    overrideRemoveAction?: boolean = true;
    gridDisableRowFn?: MxGridDisableRowFn;
    gridSelectionChangedFn?: MxGridSelectionChangedFn;
    selectionMode?: AssignmentSelectionType;
    restUrl?: string;
    props?: MxGridProps;
    callBackAction?: (result: AssignmentResult, updateItemsFn?: () => void) => void;
    assignmentConfig?: AssignmentConfig;
    callAfterSave?: () => void;
    callAfterRemove?: () => void;
    permissionFromRoute?: boolean;
    assignedItemsConfig?: {
        map?: (selected: ReadonlyArray<any>, assignedItems?: Array<any>) => Array<any>;
        removedMap?: (selected: ReadonlyArray<any>, assignedItems?: Array<any>) => Array<number>;
        source?: Observable<any>;
    };
}

export type MxReportViewInputFilterDefaultFn = () => MxReportViewInputFilterDefault[];
